





























































































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'CustomerFormModal',
  components: {
    ValidationObserver,
  },
  props: {
    customer: {
      type: Object,
      default() {
        return {
          id: null,
          email: null,
          address: null,
          city: null,
          country: null,
          first_name: null,
          last_name: null,
          phone: null,
          state: null,
          zipcode: null,
        };
      },
    },
  },
  data() {
    return {
      customerModel: null,
      formError: null,
    };
  },
  computed: {
    titleKey() {
      return this.customer.id
        ? 'CUSTOMERS.LINK.EDIT_CUSTOMER'
        : 'CUSTOMERS.LINK.ADD_CUSTOMER';
    },
  },
  methods: {
    async submitCustomer() {
      const dispatchAction = this.customer.id
        ? 'sale/updateCustomer'
        : 'sale/createCustomer';

      try {
        const dispatchPromise = await this.$store.dispatch(
          dispatchAction,
          this.customerModel
        );
        await this.$store.dispatch('customer-purchases-table/refresh');
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EDIT_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EDIT_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
  mounted() {
    this.customerModel = cloneDeep(this.customer);
  },
});
